import { render, staticRenderFns } from "./LicenseModal.vue?vue&type=template&id=d3d2a906"
import script from "./LicenseModal.vue?vue&type=script&lang=js"
export * from "./LicenseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports